import React, { useState } from "react";
import { getCookie, canUploadKyc } from "../../../Helpers/Utils";
import { useDispatch, useSelector } from "react-redux";
import White from "../../../Assets/images/white-bg.avif"
import { toast } from "react-toastify";
import Compressor from 'compressorjs';
import DatePicker from "react-multi-date-picker";
import { setCustomer, setPassport, setStep } from "../../../Reducer/customerSlice";
import moment from "moment";
import Handler from "../../../Helpers/Components/Handler";
import NextPrev from "../../../Helpers/Components/NextPrev";

const Passport = (props) => {
    const person = getCookie('person')
    const passport = useSelector(state => state?.customer?.passport)
    const customer = useSelector(state => state?.customer?.customer)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const checkFileSize = (file, fieldName, previewKey) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            dispatch(setPassport({ [fieldName]: file, [`${previewKey}`]: URL.createObjectURL(file) }));
        }
    };
    const compressImage = (file, fieldName, previewKey) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, fieldName, previewKey);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event, previewKey) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], [event.target.name], previewKey);
        }
    };
    const handleProofChange = (event, name) => {
        dispatch(setPassport({ [event.target.name]: event.target.value }))
    }
    const verifyPassport = async () => {
        if (!passport?.passport) {
            toast.error("Passport Number is required")
        } else if (!passport?.passportName) {
            toast.error("Name in Passport is required")
        } else if (!passport?.passportDate) {
            toast.error("Valid Upto is required")
        } else if (!customer?.dob) {
            toast.error("Select the customer DOB")
        } else if (!passport?.passport_photo) {
            toast.error("Passport Photo is required")
        } else if (!passport?.passport_photo_1) {
            toast.error("Three Pages of Passport Photo is required")
        } else if (!passport?.passport_photo_2) {
            toast.error("Three Pages of Passport Photo is required")
        } else {
            const formData = new FormData();
            formData.append("passport", passport?.passport);
            formData.append("passportName", passport?.passportName);
            formData.append("passportDate", moment(new Date(passport?.passportDate)).format("DD-MM-YYYY"));
            formData.append("dob", customer?.dob ? moment(new Date(customer?.dob))?.format("DD-MM-YYYY") : moment(new Date(new Date()?.setFullYear(new Date()?.getFullYear() - 18)))?.format("DD-MM-YYYY"));
            formData.append('passport_photo', passport?.passport_photo);
            formData.append('passport_photo_1', passport?.passport_photo_1);
            formData.append('passport_photo_2', passport?.passport_photo_2);
            setLoading(true)
            const response = await Handler({ method: "patch", url: `/customer/details/passport/verify/${props?.customerId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                if (response?.data?.exist) {
                    toast.error(response?.data?.message)
                }
                toast.success("Passport Verified");
                dispatch(setPassport({ passportStatus: true, passport_photo: response?.data?.passport_photo, passport_photo_1: response?.data?.passport_photo_1, passport_photo_2: response?.data?.passport_photo_2 }))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const setSteps = () => {
        dispatch(setStep(4))
    }
    const handleNext = async () => {
        if (customer?.type === "Online" && !passport?.passport) {
            toast.error("Passport is required")
        } else if (!passport?.passportName && customer?.type === "Online") {
            toast.error("Passport Name is required")
        } else if ((customer?.type === "Online" && !passport?.passportDate)) {
            toast.error("Passport valid date is required")
        } else if (!passport?.passport_photo && customer?.type === "Online") {
            toast.error("Passport photo is required")
        } else if (!passport?.passport_photo_1 && customer?.type === "Online") {
            toast.error("3 pages of Passport photo is required")
        } else if (!passport?.passport_photo_2 && customer?.type === "Online") {
            toast.error("3 pages of Passport photo is required")
        } else if (!passport?.passportStatus && customer?.type === "Online") {
            toast.error("Verify Passport")
        } else {
            if (passport?.passport || passport?.passport_photo || passport?.passport_photo_1 || passport?.passport_photo_2) {
                setLoading(true)
                const formData = new FormData();
                passport?.passportDate && formData.append('passportDate', moment(new Date(passport?.passportDate)).format("DD-MM-YYYY"));
                passport?.passportName && formData.append('passportName', passport?.passportName);
                passport?.passport && formData.append('passport', passport?.passport);
                passport?.passport_photo && formData.append('passport_photo', passport?.passport_photo);
                passport?.passport_photo_1 && formData.append('passport_photo_1', passport?.passport_photo_1);
                customer?.dob && formData.append('dob', customer?.dob ? moment(new Date(customer?.dob))?.format("DD-MM-YYYY") : moment(new Date(new Date()?.setFullYear(new Date()?.getFullYear() - 18)))?.format("DD-MM-YYYY"));
                passport?.passport_photo_2 && formData.append('passport_photo_2', passport?.passport_photo_2);
                const response = await Handler({ method: "patch", data: formData, url: `/customer/details/sixth/update/${props?.customerId}`, headers: { 'Content-Type': 'multipart/form-data' } })
                if (response?.success) {
                    if (response?.data?.exist) {
                        toast.error(response?.data?.message)
                    }
                    if (passport?.passportDate && new Date(passport?.passportDate) <= new Date()) {
                        toast.error("Passport is expired")
                    }
                    dispatch(setPassport({ passport_photo: response?.data?.passport_photo, passport_photo_1: response?.data?.passport_photo_1, passport_photo_2: response?.data?.passport_photo_2 }))
                    props?.page?.kyc ? dispatch(setStep(6)) : props?.page?.other ? dispatch(setStep(7)) : dispatch(setStep(8))
                } else {
                    toast.error(response?.message);
                }
                setLoading(false)
            } else {
                props?.page?.kyc ? dispatch(setStep(6)) : props?.page?.other ? dispatch(setStep(7)) : dispatch(setStep(8))
            }
        }
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4">
                    <div className="form-label mb-3">Passport Photo</div>
                    <div className="main-div mt-3">
                        <div className="btn-div">
                            {canUploadKyc(person, passport?.passportStatus, passport?.passport_photo) ? <label htmlFor="passport_photo" className="me-2 upload-btn">Upload</label> : ""}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (passport?.passportPhoto) { props?.setChosen(passport?.passportPhoto); props?.setProof(true) } }}>View</button>
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="passport_photo" id="passport_photo" onChange={(e) => handleImage(e, "passportPhoto")} />
                        <img src={passport?.passportPhoto || White} alt="Passport" className="kycPhotoImg" />
                    </div>
                    <div className="main-div mt-3">
                        <div className="btn-div">
                            {canUploadKyc(person, passport?.passportStatus, passport?.passport_photo_1) ? <label htmlFor="passport_photo_1" className="me-2 upload-btn">Upload</label> : ""}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (passport?.passportPhoto1) { props?.setChosen(passport?.passportPhoto1); props?.setProof(true) } }}>View</button>
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="passport_photo_1" id="passport_photo_1" onChange={(e) => handleImage(e, "passportPhoto1")} />
                        <img src={passport?.passportPhoto1 || White} alt="Passport" className="kycPhotoImg" />
                    </div>
                    <div className="main-div mt-3">
                        <div className="btn-div">
                            {canUploadKyc(person, passport?.passportStatus, passport?.passport_photo_2) ? <label htmlFor="passport_photo_2" className="me-2 upload-btn">Upload</label> : ""}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (passport?.passportPhoto2) { props?.setChosen(passport?.passportPhoto2); props?.setProof(true) } }}>View</button>
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="passport_photo_2" id="passport_photo_2" onChange={(e) => handleImage(e, "passportPhoto2")} />
                        <img src={passport?.passportPhoto2 || White} alt="Passport" className="kycPhotoImg" />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="passport" className="form-label"> Passport </label>
                        <div className="input-group mb-3">
                            <input autoComplete="off" disabled={loading || passport?.passportStatus} id="passport" type="text" name="passport" value={passport?.passport || ""} onChange={(e) => handleProofChange(e)} className="form-control input-theme text-uppercase" />
                            {passport?.passportStatus ? <span className="input-group-text" id="basic-addon2"><i className="fa-solid fa-circle-check" style={{ color: 'green' }}></i></span> : ""}
                        </div>
                    </div>


                    <div className="mb-3">
                        <label htmlFor="passportName" className="form-label"> Passport Name </label>
                        <input autoComplete="off" disabled={loading || passport?.passportStatus} id="passportName" type="text" name="passportName" value={passport?.passportName || ""} onChange={(e) => handleProofChange(e)} className="form-control input-theme text-uppercase" />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="passportDate" className="form-label"> Passport Valid Upto </label>
                        <div className=" datepicker-top"><DatePicker
                            className="input-theme"
                            value={passport?.passportDate ? new Date(passport?.passportDate) : undefined}
                            onChange={(e) => { dispatch(setPassport({ passportDate: e ? new Date(e)?.toString() : "" })) }}
                            format="DD-MM-YYYY"
                            minDate={new Date(new Date()?.setDate(new Date()?.getDate() + 1))}
                            disabled={loading || passport?.passportStatus}
                            onOpenPickNewDate={false}
                        /></div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="dob" className="form-label"> DOB </label>
                        <div className=" datepicker-top"> <DatePicker
                            className="input-theme"
                            value={customer?.dob ? new Date(customer?.dob) : ""}
                            placeholder="Select DOB"
                            onChange={(e) => { dispatch(setCustomer({ dob: new Date(e)?.toString() })) }}
                            format="DD-MM-YYYY"
                            disabled={loading || passport?.passportStatus}
                            maxDate={new Date()?.setFullYear(new Date()?.getFullYear() - 18)}
                            onOpenPickNewDate={false}
                        />
                        </div>
                    </div>
                    {
                        !passport?.passportStatus ? <button className="btn btn-sm btn-success" disabled={loading} onClick={verifyPassport}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Verify"}</button> : ""
                    }
                    {
                        passport?.passportStatus && person === "admin" ? <button className="btn btn-sm btn-success" disabled={loading} onClick={() => { dispatch(setPassport({ passportStatus: false })) }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}</button> : ""
                    }
                </div>
            </div>
            <div className="mt-3">
                {
                    (customer?.otherKyc?.length && customer?.otherKyc?.filter((element) => element?.type === "dl" || element?.type === "aadhaar" || element?.type === "passport")?.length) || customer?.secPhoto ? "" :
                        <div className="form-check my-3">
                            <input className="form-check-input" type="checkbox" id="kyc" onChange={(e) => { props?.setPage((prev) => ({ ...prev, kyc: e.target.checked })) }} checked={props?.page?.kyc} />
                            <label className="form-check-label" htmlFor="kyc"> Joint Cust KYC </label>
                        </div>
                }
                {
                    customer?.otherKyc?.length && customer?.otherKyc?.filter((element) => element?.type !== "dl" && element?.type !== "aadhaar" && element?.type !== "passport")?.length ? "" :
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="other" onChange={(e) => { props?.setPage((prev) => ({ ...prev, other: e.target.checked })) }} checked={props?.page?.other} />
                            <label className="form-check-label" htmlFor="other"> Other Doc </label>
                        </div>
                }
            </div>
            <NextPrev step={5} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />

        </React.Fragment>
    )
}

export default Passport;